import { MapTo } from '@adobe/aem-react-editable-components';
import RbpLetter, { RbpLetterEditConfig } from './RbpLetter';

export default MapTo('cob-corp-acquisition/components/creditonebank/rbp-letter')(RbpLetter, RbpLetterEditConfig);